import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsLayout } from './settings.layout';
import { CustomerGuard } from '../../_guards/customer.guard';
import { OrganisationGuard } from 'src/app/_guards/organisation.guard';
import { WhitelabelGuard } from 'src/app/_guards/whitelabel.guard';
import { SystemGuard } from 'src/app/_guards/system.guard';
import { SettingsApplicationRequestsPage } from 'src/app/components/settings/application/requests/settings-application-requests.page';
import { DocumentsPage } from 'src/app/components/settings/application/documents/documents.page';
import { SettingsAccountSecurityPage as SettingsAccountSecurityPage } from 'src/app/components/settings/account/security/account-security.page';
import { EmailPage } from 'src/app/components/settings/application/email/email.page';
import { SigningPage } from 'src/app/components/settings/application/signing/signing.page';
import { AddressbookPage } from 'src/app/components/settings/integrations/addressbook/addressbook.page';
import { IntegrationsDocumentsPage } from 'src/app/components/settings/integrations/documents/documents.page';
import { ServicesPage } from 'src/app/components/settings/integrations/services/services.page';
import { GeneralPage } from 'src/app/components/settings/security/general/general.page';
import { IdentityPage } from 'src/app/components/settings/security/identity/identity.page';
import { ValidationPage } from 'src/app/components/settings/security/validation/validation.page';
import { SsoPage } from 'src/app/components/settings/security/sso/sso.page';
import { SettingsOrganisationOverviewPage } from 'src/app/components/settings/organisation/overview/settings-organisation-overview.page';
import { SettingsOrganisationUsersPage } from 'src/app/components/settings/organisation/users/settings-organisation-users.page';
import { SettingsOrganisationWorkgroupsPage } from 'src/app/components/settings/organisation/workgroups/settings-organisation-workgroups.page';
import { OrganisationLayout } from './organisation/organisation.layout';
import { OrganisationUserLayout } from './organisation/users/organisation-user.layout';
import { AccountProfilePage } from './account/profile/account-profile.page';
import { OrganisationUserProfilePage } from './organisation/users/profile/organisation-user-profile.page';
import { AccountSignaturePage } from './account/signature/account-signature.page';
import { OrganisationUserSignaturePage } from './organisation/users/signature/organisation-user-signature.page';
import { AccountWorkgroupsPage } from './account/workgroups/account-workgroups.page';
import { OrganisationUserWorkgroupsPage } from './organisation/users/workgroups/organisation-user-workgroups.page';
import { OrganisationUserRolesPermissionsPage } from './organisation/users/roles-permissions/organisation-user-roles-permissions.page';
import { AccountRolesPermissionsPage } from './account/roles-permissions/account-roles-permissions.page';
import { PlatformApiPage } from './integrations/platformapi/platformapi.page';
import { WhiteLabelLayout } from './whitelabel/whiteLabel.layout';
import { SettingsWhiteLabelOverviewPage } from './whitelabel/overview/settings-whitelabel-overview.page';
import { SettingsWhitelabelOrganisationsPage } from './whitelabel/organisations/settings-whitelabel-organisations.page';
import { OrganisationBrandingPage, SystemBrandingPage, WhitelabelBrandingPage } from './branding/branding.page';
import { OrganisationStoragePage, SystemStoragePage, WhiteLabelStoragePage } from './storage/storage.page';
import { SettingsOrganisationCreditsPage } from './credits/settings-organisation-credits.page';
import { SettingsSystemOverviewPage } from './system/overview/settings-system-overview.page';
import { SettingsWhiteLabelCreditsPage } from './credits/settings-whitelabel-credits.page';
import { SettingsSystemWhiteLabelProvidersPage } from './system/whitelabelproviders/settings-system-whitelabelproviders.page';
import { SettingsOrganisationPermissionsPage } from './permissions/settings-organisation-permissions.page';
import { SettingsWhitelabelPermissionsPage } from './permissions/settings-whitelabel-permissions.page';
import { SettingsSystemPermissionsPage } from './permissions/settings-system-permissions.page';

export const SettingSubRoutes: Routes = [
  { path: '', redirectTo: 'account', pathMatch: 'full' },
  {
    path: '',
    canActivate: [CustomerGuard],
    component: SettingsLayout,
    children: [
      // --------- ACCOUNT  -----------
      {
        path: 'account',
        children: [
          { path: '', redirectTo: 'profile', pathMatch: 'full' },
          { path: 'profile', component: AccountProfilePage },
          { path: 'signature', component: AccountSignaturePage },
          { path: 'security', component: SettingsAccountSecurityPage },
          { path: 'roles', component: AccountRolesPermissionsPage },
          { path: 'workgroups', component: AccountWorkgroupsPage },
        ]
      },
      // --------- APPLICATION  -----------
      {
        path: 'application/:organisationId',
        component: OrganisationLayout,
        canActivate: [OrganisationGuard],
        children: [
          { path: '', redirectTo: 'requests', pathMatch: 'full' },
          { path: 'requests', component: SettingsApplicationRequestsPage },
          { path: 'documents', component: DocumentsPage },
          { path: 'email', component: EmailPage },
          { path: 'signing', component: SigningPage },
        ]
      },
      // --------- SECURITY  -----------
      {
        path: 'security/:organisationId',
        component: OrganisationLayout,
        canActivate: [OrganisationGuard],
        children: [
          { path: '', redirectTo: 'general', pathMatch: 'full' },
          { path: 'general', component: GeneralPage },
          { path: 'identity', component: IdentityPage },
          { path: 'validation', component: ValidationPage },
          { path: 'sso', component: SsoPage },
        ]
      },
      // --------- INTERGRATIONS  -----------
      {
        path: 'integrations/:organisationId',
        component: OrganisationLayout,
        canActivate: [OrganisationGuard],
        children: [
          { path: '', redirectTo: 'platformApi', pathMatch: 'full' },
          { path: 'platformApi', component: PlatformApiPage },
          { path: 'documents', component: IntegrationsDocumentsPage },
          { path: 'addressbook', component: AddressbookPage },
          { path: 'services', component: ServicesPage },
        ]
      },
      // --------- ORGANISATION  -----------
      {
        path: 'organisation/:organisationId',
        component: OrganisationLayout,
        canActivate: [OrganisationGuard],
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          { path: 'overview', component: SettingsOrganisationOverviewPage },
          // ---- SUBSECTION ORGANISATION -> USERS -> USER SPECIFIC
          {
            path: 'users',
            children: [
              { path: '', component: SettingsOrganisationUsersPage, pathMatch: 'full' },
              {
                path: ':userId',
                component: OrganisationUserLayout,
                children: [
                  { path: '', redirectTo: 'profile', pathMatch: 'full' },
                  { path: 'profile', component: OrganisationUserProfilePage },
                  { path: 'signature', component: OrganisationUserSignaturePage },
                  { path: 'roles', component: OrganisationUserRolesPermissionsPage },
                  { path: 'workgroups', component: OrganisationUserWorkgroupsPage },
                ]
              },
            ]
          },
          { path: 'workgroups', component: SettingsOrganisationWorkgroupsPage },
          { path: 'credits', component: SettingsOrganisationCreditsPage },
          { path: 'storage', component: OrganisationStoragePage },
          { path: 'branding', component: OrganisationBrandingPage },
          { path: 'permissions', canActivate: [WhitelabelGuard], component: SettingsOrganisationPermissionsPage }
        ]
      },
      // --------- WHITELABEL  -----------
      {
        path: 'whitelabel/:whitelabelId',
        component: WhiteLabelLayout,
        canActivate: [WhitelabelGuard],
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          { path: 'overview', component: SettingsWhiteLabelOverviewPage },
          { path: 'organisations', component: SettingsWhitelabelOrganisationsPage },
          { path: 'credits', component: SettingsWhiteLabelCreditsPage },
          { path: 'storage', component: WhiteLabelStoragePage },
          { path: 'branding', component: WhitelabelBrandingPage },
          { path: 'permissions', component: SettingsWhitelabelPermissionsPage },
        ]
      },
      // --------- SYSTEM  -----------
      {
        path: 'system',
        canActivate: [SystemGuard],
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          { path: 'overview', component: SettingsSystemOverviewPage },
          { path: 'whitelabelproviders', component: SettingsSystemWhiteLabelProvidersPage },
          { path: 'storage', component: SystemStoragePage },
          { path: 'branding', component: SystemBrandingPage },
          { path: 'permissions', component: SettingsSystemPermissionsPage },
        ]
      },
      // --------- WILD CARD BABE!!!!!!  -----------
      {
        path: '**',
        redirectTo: 'account/profile'
      },
    ]
  },
];


@NgModule({
  imports: [RouterModule.forChild(SettingSubRoutes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
